module.exports = __webpack_public_path__ + "static/media/canimolt_BannersCenso_PPT.1ca92879.jpg";